import type { IHttpClient } from '@/services/http';

/**
 * Base API Class (Framework Agnostic)
 * 
 * Abstract base for all API endpoint classes.
 * Provides access to the HTTP client through the api getter.
 */
export abstract class Api {
  protected constructor() {}

  /**
   * Get the HTTP client instance
   * Subclasses must provide their specific HTTP client instance
   */
  protected abstract get api(): IHttpClient;
}
